import { Grid } from '@material-ui/core';
import { COOKIE_AUTH_DETAILS } from 'globalconfig/constants/keys';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import { BACKEND_DATE_FORMAT } from 'globalconfig/constants/static';
import { getCookie } from 'globalservices/cookie';
import { DOMAIN_CONFIG } from 'globalutils/constants';
import { getAuthDetails, hasValue } from 'globalutils/fmUtils';
import { findKey } from 'lodash';
import moment from 'moment';
import React, { lazy, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import RenderComponent from './RenderComponent';
import { validationSchema } from './schema';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Form = lazy(() => import(`globalcomponents/UI/Form/${layout}`));
const SubHeader = lazy(() => import(`globalcomponents/SubHeader/${layout}`));
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const SuccessIcon = lazy(() => import(`globalcomponents/SuccessIcon/${layout}`));
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));

const QuestionnaireBannerForm = ({ action: onCancelModal }) => {
  const { i18n } = useTranslation();
  const auth = getAuthDetails();
  const { gigBanner: gigBannerDispatch } = useDispatch();
  const [showThanks, setShowThanks] = useState(false);
  const apiStatus = useSelector((state) => state.asyncRequests);
  const [errorMessage, setErrorMessage] = useState('');

  const hasApiStatus = hasValue(apiStatus.status, 'api', 'saveGigBanner');

  const onSubmit = async (fields) => {
    const responseObj = {
      hasCameras: fields?.haveCamera === 'yes' ? true : false,
      cameraProvider: fields?.haveCamera ? fields?.cameraProvider : null,
      insuranceProvider: fields?.insuranceProvider || null,
      policyRenewDate: moment(fields?.endDate).format(BACKEND_DATE_FORMAT) || null,
      email: fields?.email || null,
      phone: fields?.phone || null,
    };

    await gigBannerDispatch.saveGigBanner({
      data: responseObj,
      apiId: 'saveGigBanner',
      callback: (isSuccess, response, error) => {
        if (isSuccess) {
          localStorage.setItem('bannerDate', 'submitted');
          setShowThanks(true);
        } else if (error) {
          setErrorMessage(error);
        }
      },
    });
  };

  const onGetaQuotes = () => {
    const cookie = getCookie(COOKIE_AUTH_DETAILS);
    const token = cookie?.token;
    const client = findKey(DOMAIN_CONFIG, (value) => value === window.$environment.SERVICE_PROVIDER) || 'GORILLA';
    if (token && client) {
      window.open(`${window?.$environment?.FE_GIG_URL}login?token=${token}&client=${client}`, '_blank');
    }
  };

  const thanksComponent = (
    <>
      <Grid container justify="center">
        <SuccessIcon />
        <SubHeader text={i18n.t('banner.thankYou')} className="subHeaderNew" variant="h1" />
        <div className="buttonWrap">
          <Button type="submit" className="buttonQuotes" label={i18n.t('common.getaQuotes')} onClick={() => onGetaQuotes()} />
          <Button type="submit" className="buttonStyle" label={i18n.t('banner.close')} onClick={() => onCancelModal(true)} />
        </div>
      </Grid>
    </>
  );

  const customProps = {
    errorMessage: hasApiStatus ? hasApiStatus?.errorMessage : errorMessage,
  };

  return showThanks ? (
    thanksComponent
  ) : (
    <>
      <div id="closeBtn">
        <Icon onClick={() => onCancelModal()} src={mediaUrls?.closeIcon}></Icon>
      </div>
      <Form
        type="server"
        direction="column"
        initialValues={{
          haveCamera: 'no',
          email: auth?.sub || '',
          cameraProvider: '',
          phone: '',
          insuranceProvider: '',
        }}
        RenderComponent={RenderComponent}
        handleOnSubmit={onSubmit}
        customProps={customProps}
        handleOnCancel={() => onCancelModal()}
        validationSchema={Yup.object().shape({
          ...validationSchema,
        })}
      />
    </>
  );
};

QuestionnaireBannerForm.propTypes = {};

export default QuestionnaireBannerForm;
